import { InputValidationComponent } from 'core/validation/input/input-validation.component'
import { FormValidationComponent } from 'core/validation/form/form-validation.component'
import { Counter } from 'components/counter/counter'
import { Message } from 'components/message'
import { Pbm } from '../pbm'
import { PbmLoginMask } from './pbm-login.mask'
import { constraints } from './pbm-login.constraints'
import { Observable } from 'rxjs'

export class PbmLoginComponent {
    constructor() {
        this.element = document.querySelector("#pbm-form")
        this.inputQuantidadeElement = document.querySelector('input[name="quantidadeSolicitada"]')
        this.validator = new FormValidationComponent(this.element, constraints)
        this.pbmButtonComprar = document.getElementById('pbm-form-comprar')
        this.pbmButtonComprarSubmitStream = Observable.fromEvent(this.pbmButtonComprar, 'click')
        this.pbmButtonAutorizar = document.getElementById('pbm-form-autorizar')
        this.pbmButtonAutorizarSubmitStream = Observable.fromEvent(this.pbmButtonAutorizar, 'click')
        
        this.init()
    }

    init() {

        if (this.element) {

            //counter
            if(this.element.querySelector('.counter'))
                new Counter(this.element.querySelector('.counter'), this.inputQuantidadeElement)

            //masks
            const masks = new PbmLoginMask()

            //input validation
            new InputValidationComponent(this.element, constraints).init()
            
            // autorizar
            this.pbmButtonComprarSubmitStream
                .do(event => event.preventDefault())
                .filter(event => this.validator.validateForm())
                .filter(event => this.validateForm())
                .map(event => this.validator.serializeForm())
                .subscribe(pbm => { this.validarDesconto(pbm, false) })
            
            // pre-autorizar
            this.pbmButtonAutorizarSubmitStream
                .do(event => event.preventDefault())
                .filter(event => this.validator.validateForm())
                .filter(event => this.validateForm())
                .map(event => this.validator.serializeForm())
                .subscribe(pbm => { this.validarDesconto(pbm, true) })
        }
    }

    validarDesconto(pbm, status) {
        pbm.consultaPreco = status
        return new Pbm(pbm);
    }

    validateForm() {
        if((this.element.querySelector('#nroCartao') && this.element.querySelector('#nroCpf'))
            && this.element.querySelector('#nroCartao').value == ""
            && this.element.querySelector('#nroCpf').value == ""){

                    new Message("Digite o Número do cartão ou CPF");
                    return false;

        }else if((this.element.querySelector('#nroCartao') && this.element.querySelector('#nroCpf'))
                && this.element.querySelector('#nroCartao').value != ""
                && this.element.querySelector('#nroCpf').value != "" ) {

                    new Message("Digite apenas o Número do cartão ou do CPF");
                    return false;

        }else {
            return true;
        }
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-login/pbm-login.component.js